import animateScrollTo from "animated-scroll-to";

export const handleFieldError = (
  id: string,
  scrollContainerElementId?: string,
  options?: {
    cancelOnUserAction?: boolean;
    horizontalOffset?: number;
    maxDuration?: number;
    minDuration?: number;
    passive?: boolean;
    speed?: number;
    verticalOffset?: number;
  },
) => (errors: any) => {
  const form = document.getElementById(id) as HTMLElement;
  const firstFormFieldError = form.querySelector(".field-error") as HTMLElement;

  const scrollReferenceElement = scrollContainerElementId ? document.getElementById(scrollContainerElementId)! : window;

  if (firstFormFieldError) {
    animateScrollTo(firstFormFieldError, { ...(options ?? {}), elementToScroll: scrollReferenceElement });
  } else {
    console.error(
      `Could not find a Field with the class .field-error within Form ${id}, but the following errors occurred: `,
      errors,
    );

    alert("One or more validation errors exist. Please ensure the form is valid before attempting to re-submit.");
  }
};
